import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import {
  ANALYSIS_STATUS,
  ELIGIBILITY_SECTIONS,
} from '@/data/Party/eligibilityAssistant'

export const ELIGIBILITY_ASSISTANT_NAMESPACE = 'eligibilityAssistant'

export const EligibilityAssistant = {
  namespaced: true,
  state: () => ({
    analysisOptions: ANALYSIS_STATUS,
    eligibilitySections: ELIGIBILITY_SECTIONS,
  }),
  getters: {
    analysisOptions: state => state.analysisOptions,
    eligibilitySections: state => state.eligibilitySections,
  },
  mutations: {
    setAnalysisOptions (state, value) {
      state.analysisOptions = value
    },
    setEligibilitySections (state, value) {
      state.eligibilitySections = value
    },
  },
  actions: {
    getPartyEligibilities: async (_, partyId) => {
      return axiosRequest.
        get(`/parties/${partyId}/party_eligibilities`).
        then(response => response.data).
        catch(handleError)
    },
    savePartyEligibility: async (_, requestData) => {
      return axiosRequest.
        post(`/parties/${requestData.partyId}/party_eligibilities`, { section: requestData.section }).
        then(response => response.data).
        catch(handleError)
    },
  },
}
